import * as React from 'react';
import { useEffect, useState } from 'react';
import { useWindowSize } from './useWindowSize';

export const useDimensions = <T extends HTMLElement> (ref: React.MutableRefObject<T>) => {
    const [width, setWidth] = useState<number>(null);
    const [height, setHeight] = useState<number>(null);
    const [windowWidth] = useWindowSize();

    useEffect(() => {
        if (ref.current) {
            const box = ref.current.getBoundingClientRect();

            setWidth(Math.round(box.width));
            setHeight(Math.round(box.height));
        }
    }, [ref.current, windowWidth]);

    return [width, height];
};
